/**
 * A unit word shown after a number: one form for every count, or CLDR plural
 * forms (`other` required) for languages whose noun changes with the count,
 * e.g. Lithuanian 1 diena, 6 dienos, 12 dienų, 2,5 dienos.
 */
export type UnitLabel = string | (Partial<Record<Intl.LDMLPluralRule, string>> & { other: string });

/** Pick the form for `count` under the locale's plural rules; without a count, `other`. */
export function selectUnitLabel(label: UnitLabel, locale: string, count?: number): string {
	if (typeof label === "string") return label;
	if (count === undefined || !Number.isFinite(count)) return label.other;
	return label[new Intl.PluralRules(locale).select(count)] ?? label.other;
}

/** The number directly before a unit in free text: "~4-6 hours" → 6, "~2,5 days" → 2.5. */
export function countBefore(text: string): number | undefined {
	const match = /(\d+(?:[.,]\d+)?)\s*$/u.exec(text);
	return match ? Number(match[1].replace(",", ".")) : undefined;
}
